module.exports = new __parcel__URL__("rotten-tomatoes.474b9667.svg").toString();